import React from 'react'

class PressableHeader extends React.Component {
	render() {
		return <div className="dh">
			<div className="navbar">
				<div className="navbar-inner">
					<img className="dreamhost-logo" src="/assets/migration/pressable-logo.png" alt="Pressable"/>
					<img className="blogvault-logo" src="/assets/powered-by-blogvault-logo.png" alt="Powered by BlogVault"/>
				</div>
			</div>
		</div>
	}
}

export default PressableHeader
